(function ($) {
  const timeline_icon = $(".period-carousel__icon");
  const seperators = timeline_icon.find(".seperator");

  if (timeline_icon.length >= 2) {
    var first = $(timeline_icon[0]);
    var second = $(timeline_icon[1]);
  }

  $(window).on("load resize", function () {
    if (timeline_icon.length >= 2) {
      var first_width = first.outerWidth();
      var first_offset = first.offset();
      var second_offset = second.offset();

      var newWidth = second_offset.left - (first_offset.left + first_width);

      seperators.each(function () {
        $(this).css("width", newWidth + "px");
      });
    }
  });
})(jQuery);
